import Vue from 'vue'
import App from './App.vue'
import router from '../router'
import './assets/css/common.css'
import axios from './assets/js/axios'
import api from './assets/js/api'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import myMixin from '@/minx/index';
import './plugins/imagePreview'


Vue.mixin(myMixin);
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.$url = api
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
